import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import type { TechnologyTreeSearch } from "../../../../components/WMS/Technologies/TechnologyTreePage"
import LazyRoutePage from "../../../-LazyRoutePage"

const TechnologyTreePage = lazy(
  () => import("../../../../components/WMS/Technologies/TechnologyTreePage"),
)

export const Route = createFileRoute("/_layout/WMS/technologies/tree")({
  validateSearch: (search: Record<string, unknown>): TechnologyTreeSearch => {
    const parsedDepth =
      typeof search.max_depth === "number"
        ? search.max_depth
        : typeof search.max_depth === "string"
          ? Number.parseInt(search.max_depth, 10)
          : 10
    return {
      root_product_id:
        typeof search.root_product_id === "string"
          ? search.root_product_id
          : undefined,
      root_technology_id:
        typeof search.root_technology_id === "string"
          ? search.root_technology_id
          : undefined,
      missing_product_id:
        typeof search.missing_product_id === "string"
          ? search.missing_product_id
          : undefined,
      active_only: !(
        search.active_only === false || search.active_only === "false"
      ),
      max_depth: Math.min(20, Math.max(1, parsedDepth || 10)),
    }
  },
  component: TechnologyTreeRoute,
})

function TechnologyTreeRoute() {
  return (
    <LazyRoutePage>
      <TechnologyTreePage />
    </LazyRoutePage>
  )
}
